"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AnimatorContent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AnimatorContent, _React$Component);

  function AnimatorContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = AnimatorContent.prototype;

  _proto.cleanProps = function cleanProps(props) {
    var newProps = Object.assign({}, props);
    delete newProps.animatorChildClassName;
    delete newProps.animatorChildStyle;
    return newProps;
  };

  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/_react["default"].createElement(children.type || 'div', this.cleanProps(children.props), children.props ? children.props.children : children);
  };

  return AnimatorContent;
}(_react["default"].Component);

var _default = AnimatorContent;
exports["default"] = _default;